import React from 'react';
import { createRoot } from 'react-dom/client';
import { Rocket } from 'lucide-react';

// Rocket animation component
const RocketLoader = () => {
  const keyframesStyle = `
    @keyframes fly {
      0% {
        transform: translateY(60px) rotate(-45deg);
      }
      50% {
        transform: translateY(-60px) rotate(-45deg);
      }
      100% {
        transform: translateY(60px) rotate(-45deg);
      }
    }
  `;

  React.useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = keyframesStyle;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="relative h-32 w-full flex justify-center">
        <div
          className="text-blue-500"
          style={{ animation: 'fly 2s ease-in-out infinite' }}
        >
          <Rocket size={36} />
        </div>
      </div>
    </div>
  );
};

class StandaloneLoader {
  private loaderContainer: HTMLDivElement | null = null;
  private alertContainer: HTMLDivElement | null = null;
  private loaderRoot: any = null;
  private alertRoot: any = null;

  private createLoaderContainer() {
    this.loaderContainer = document.createElement('div');
    document.body.appendChild(this.loaderContainer);
    this.loaderRoot = createRoot(this.loaderContainer);
  }

  private createAlertContainer() {
    this.alertContainer = document.createElement('div');
    document.body.appendChild(this.alertContainer);
    this.alertRoot = createRoot(this.alertContainer);
  }

  showLoader() {
    if (!this.loaderContainer) this.createLoaderContainer();
    this.loaderRoot.render(<RocketLoader />);
  }

  hideLoader() {
    if (this.loaderContainer) {
      this.loaderRoot.unmount();
      this.loaderContainer.remove();
      this.loaderContainer = null;
    }
  }

  showAlert(message: string) {
    if (!this.alertContainer) this.createAlertContainer();
    this.alertRoot.render(
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full mx-4">
          <p className="text-gray-800">{message}</p>
          <button
            className="mt-4 w-full bg-black text-white py-2 rounded"
            onClick={() => {
              this.hideAlert();
            }}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  hideAlert() {
    if (this.alertContainer) {
      this.alertRoot.unmount();
      this.alertContainer.remove();
      this.alertContainer = null;
    }
  }
}

export const standaloneLoader = new StandaloneLoader();
